import { HttpClient, HttpResponse } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from '../../app.constants';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  public resourceUrl = SERVER_API_URL + 'api/device';

  constructor(protected http: HttpClient) {}

  openDoor(location: string, userId: string, deviceId: string): Observable<HttpResponse<any>> {
    const data = {
      locationId: location,
      jhiUserId: userId,
      deviceId,
    };
    return this.http.post<HttpResponse<any>>(`${this.resourceUrl}/open-door`, data, {
      observe: 'response',
    });
  }
}
